<div class="relative aspect-[767/649] h-full w-full md:aspect-[1022/425] lg:aspect-[1920/600]">
    <video
        class="h-full w-full object-cover"
        #video
        [src]="videoUrl()"
        autoplay
        muted
        loop
        playsinline
        preload="auto"
    ></video>

    <button
        class="text-18 absolute right-0 bottom-0 z-10 px-32 py-24 text-white"
        [attr.aria-label]="isPlaying() ? 'Video pausieren' : 'Video abspielen'"
        (click)="togglePlay(video)"
        type="button"
    >
        @if (isPlaying()) {
            <i class="icon-pause" aria-hidden="true"></i>
        } @else {
            <i class="icon-play" aria-hidden="true"></i>
        }
    </button>
</div>
